export default {"src":"/_next/static/media/walk-score.a9107280.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};